import { useState, useEffect } from "react";
import { Icon, Snackbar, Alert, Typography, Card } from "@mui/material";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import Africastalking from "africastalking-client";
import VoiceDialer from "app/components/call_dialer";

function AfDialer() {
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setSeverity("error");
  };

//   const client = new Africastalking.Client("ATCAPtkn_9f3855ea92d1a2bffe123a3c0ea93eb736296addb52245023321d9d21a63f62c");
//   function initDailer() {
//     client.on(
//       "incomingcall",
//       function (params) {
//         alert(`${params.from} is calling you`);
//       },
//       false,
//     );

//     client.on(
//       "hangup",
//       function (hangupCause) {
//         alert(`Call hung up (${hangupCause.code} - ${hangupCause.reason})`);
//       },
//       false,
//     );
//   }

//   useEffect(() => {
//     initDailer();
//   }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={10}>
        <MDBox m={2} display="flex" justifyContent="space-between">
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" align="center">
              AF Dialer
            </MDTypography>
          </MDBox>
          <MDBox>
            <MDTypography variant="h6">
              <Icon color="dark">call</Icon>
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox>
            <VoiceDialer token="ATCAPtkn_badef6a27f44187bdd353cc6584861be90e7a85b482dad35327bb37d30832d7f" />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AfDialer;
